import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../auth/service/auth';
import { map, take, filter } from 'rxjs/operators';

export const authGuard: CanActivateChildFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  // Wait for Firebase auth state to be initialized, then check authentication
  return authService.authInitialized$.pipe(
    filter(isInitialized => isInitialized), // Only proceed when auth is initialized
    take(1),
    map((isInitialized) => {
      
      // Check if user is authenticated after auth state is initialized
      if (authService.isAuthenticated()) {
        // console.log('Auth guard: User is authenticated, allowing access');
        return true;
      }
      
      // User is not authenticated, redirect to login
      // console.log('Auth guard: User not authenticated, redirecting to login');
      return router.createUrlTree(['/auth/splash']);
    })
  );
}; 
